export { Icon } from '@wordpress/icons';

export { default as lifterlms } from './lifterlms';
